import React from 'react';

export default function ProductDescription({ description, className }) {
    return (
        <div style={{ display: 'flex' }}>
            <p className={`product-description ${className || ""}`} style={{ color: '#fff', fontSize: '16px' }}>
                {
                    typeof description == "string" 
                        ? description.split("\n").map(function(item, idx) {
                            let tab = item[0];
                            return (
                                <span key={idx} style={{ marginLeft: tab === '-' || (typeof +tab == "number" && +tab) ? 30: 0 }}>
                                    {item}
                                    <br/>
                                </span>
                            )
                        })
                        : description.map(item =>
                            item.split("\n").map(function(item, idx) {
                                let tab = item[0];
                                return (
                                    <span key={idx} style={{ marginLeft: tab === '-' || (typeof +tab == "number" && +tab) ? 30: 0 }}>
                                        {item}
                                        <br/>
                                    </span>
                                )
                            })
                        )
                }
            </p>
        </div >
    );
}
